import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { Utils } from "../../utils/utils";
import { RiskIndicator } from "../../interfaces/riskIndicator";

@Component({
  selector: "app-edit-risk-indicator-dialog",
  templateUrl: "./edit-risk-indicator-dialog.component.html",
  styleUrls: ["./edit-risk-indicator-dialog.component.scss"],
})
export class EditRiskIndicatorDialogComponent
  extends MzBaseModal
  implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  error: string;

  @Input() project: Project;
  @Input() riskIndicators: RiskIndicator[];

  @Output()
  createRiskIndicatorClicked: EventEmitter<any> = new EventEmitter<any>();

  newRiskIndicator: RiskIndicator;
  canCreate: boolean;

  constructor() {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.newRiskIndicator = {} as RiskIndicator;
  }

  async validate(newValue) {
    let nameNotEmpty = newValue && newValue.trim() !== "";
    let nameAlreadyExists =
      this.riskIndicators &&
      this.riskIndicators.filter(
        (x) =>
          x.name.localeCompare(newValue, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "search",
          }) === 0
      ).length > 0;
    this.canCreate = nameNotEmpty && !nameAlreadyExists;
    this.error = nameAlreadyExists
      ? "Ein Indikator mit dieser Bezeichnung existiert bereits."
      : null;
  }

  /**
   * creates new Item
   */
  createRiskIndicator() {
    if (this.canCreate) {
      this.newRiskIndicator.projectId = this.project._id;
      this.createRiskIndicatorClicked.emit(this.newRiskIndicator);
      this.newRiskIndicator = {} as RiskIndicator;
      this.canCreate = false;
    }
  }

  /**
   * resets newItem object and closes modal
   * @param modal
   */
  closeSprintModal() {
    this.newRiskIndicator = {} as RiskIndicator;
    this.canCreate = false;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/edit-risk-indicator-dialog/edit-risk-indicator-dialog.component.ts